/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HorseActivity } from '../models/HorseActivity';
import { HttpFile } from '../http/http';

export class PaginatedActivity {
    'results': Array<HorseActivity>;
    'next'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "results",
            "baseName": "results",
            "type": "Array<HorseActivity>",
            "format": ""
        },
        {
            "name": "next",
            "baseName": "next",
            "type": "number",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return PaginatedActivity.attributeTypeMap;
    }

    public constructor() {
    }
}

